// AUTO-GENERATED from servers/common-servers-v2/helpers/FormHelper/ids.js by servers/common-servers-v2/scripts/sync-form-helper.js.
// Do not edit: change the source and run `node scripts/sync-form-helper.js`.
/* eslint-disable */
import { KEY_PREFIX } from "./constants.js";

const ALPHABET = "abcdefghijklmnopqrstuvwxyz0123456789";
const KEY_LENGTH = 8;
// Largest multiple of the alphabet size below 256, so the modulo is unbiased.
const BYTE_LIMIT = 256 - (256 % ALPHABET.length);

const random_bytes = (count) => {
    const web_crypto = globalThis.crypto;
    if (web_crypto && typeof web_crypto.getRandomValues === "function") {
        return web_crypto.getRandomValues(new Uint8Array(count));
    }
    // Node without a global crypto (< 19).
    throw new Error("FormHelper: no secure random source (globalThis.crypto) in this runtime");
};

const random_chars = (length) => {
    let result = "";
    while (result.length < length) {
        const bytes = random_bytes((length - result.length) * 2);
        for (let i = 0; i < bytes.length && result.length < length; i += 1) {
            if (bytes[i] < BYTE_LIMIT) {
                result += ALPHABET[bytes[i] % ALPHABET.length];
            }
        }
    }
    return result;
};

const make_group_key = () => KEY_PREFIX.group + random_chars(KEY_LENGTH);
const make_field_key = () => KEY_PREFIX.field + random_chars(KEY_LENGTH);
const make_option_value = () => KEY_PREFIX.option + random_chars(KEY_LENGTH);

export {
    make_group_key,
    make_field_key,
    make_option_value,
};
